<script>
import {get} from "lodash";
import StarRating from 'vue-star-rating'

export default {
  name: "StarsCell",
  props: ['row', 'column', 'index', 'hover'],
  components: {
    StarRating
  },
  computed: {
    isHoveredRow() {
      return this.hover === this.row.id
    },
    rating() {
      return  get(this.row, this.column.prop, 0);
    },
  },
}
</script>

<template>
  <StarRating
    :rating="rating"
    :border-width="0"
    :round-start-rating="false"
    :show-rating="false"
    :star-size="16"
    :read-only="true"
    :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
  />
</template>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/StarsCell/StarsCell.vue